import React from 'react';
import { SharedResourcesList } from './SharedResources';

const SharedMarkingTools = () => {
  return (
    <SharedResourcesList
      resourceCategory={null}
      allowedResourceTypes={['MARKING_TEMPLATE', 'COMMENT_BANK', 'SUCCESS_CRITERIA', 'SHORT_ANSWERS']}
      resourceNameColumnLabel={<span data-dd-privacy="mask-user-input">Name</span>}
      emptyMessage="No marking tools have been shared with you yet."
      noMatchesMessage="No shared marking tools match these filters."
      successConfig={{
        message: (resource) => {
          const resourceType = resource?.resourceType || resource?.itemType || resource?.documentType;
          if (resourceType === 'COMMENT_BANK' || resourceType === 'COMMENT_BANKS') {
            return `The shared comment bank has been added to your Comment Banks.`;
          }
          if (resourceType === 'SUCCESS_CRITERIA') {
            return `The shared success criteria has been added to your Success Criterias.`;
          }
          if (resourceType === 'SHORT_ANSWERS') {
            return `The shared short answer has been added to your Short Answers.`;
          }
          return `The shared marking template has been added to your Rubrics.`;
        },
        redirectPath: (resource) => {
          const resourceType = resource?.resourceType || resource?.itemType || resource?.documentType;
          if (resourceType === 'COMMENT_BANK' || resourceType === 'COMMENT_BANKS') {
            return '/#/tools/commentbanks';
          }
          if (resourceType === 'SUCCESS_CRITERIA') {
            return '/#/tools/successcriterias';
          }
          if (resourceType === 'SHORT_ANSWERS') {
            return '/#/tools/shortanswers';
          }
          return '/#/tools/markingcriterias';
        },
        buttonLabel: (resource) => {
          const resourceType = resource?.resourceType || resource?.itemType || resource?.documentType;
          if (resourceType === 'COMMENT_BANK' || resourceType === 'COMMENT_BANKS') {
            return 'Go to Comment Banks';
          }
          if (resourceType === 'SUCCESS_CRITERIA') {
            return 'Go to Success Criterias';
          }
          if (resourceType === 'SHORT_ANSWERS') {
            return 'Go to Short Answers';
          }
          return 'Go to Rubrics';
        },
      }}
      rejectConfig={{
        title: 'Reject shared template?',
        message: 'Once rejected the shared template will be lost forever. Are you sure you want to continue?',
      }}
    />
  );
};

export default SharedMarkingTools;

